module.exports = __webpack_public_path__ + "static/media/uberEats.8bc0d121.png";